import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import {
  NDHMGenericApiResponse,
  TPostCreateHealthFacilityParam,
} from "../../types/axon";

export default async function postCreateHealthFacility({
  clinicId,
  clinicName,
  clinicAddress,
  clinicPincode,
  doctorId,
}: TPostCreateHealthFacilityParam): Promise<
  NDHMGenericApiResponse<{ facility_id: string }>
> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({
        id: clinicId,
        name: clinicName,
        pincode: clinicPincode,
        address: clinicAddress,
    });

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(`${NDHM_HOST}/abdm/nhpr/v1/hfr/onboard?doctor_oid=${doctorId}`, requestOptions);
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
